import { get_api_path } from "services/api";
import { getBinaryFromFile } from "utils/fileUtils";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("routine/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(routine_id) {
  const url = get_api_path("routine/detail", {}, { routine_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(routine_id) {
  const url = get_api_path("routine/delete", {}, { routine_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(routine_id, data) {
  const url = get_api_path("routine/update", {}, { routine_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(module_id, data) {
  const url = get_api_path("routine/create", {}, { module_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function image(routine_id, file) {
  const headers = { 'X-Name': file.name, 'Content-Type' : file.type };
  const data = await getBinaryFromFile(file);
  const url = get_api_path("routine/image", null, { routine_id });
  const { token } = store.getState().profile;
  let response = await sessioned_client(token).post(url, data, { headers });
  const { model } = response.data.result;
  return model;
}

export async function create_visual(routine_id, file) {
  const headers = { 'X-Name': file.name, 'Content-Type' : file.type };
  const data = await getBinaryFromFile(file);
  const url = get_api_path("routine/visual/create", null, { routine_id });
  const { token } = store.getState().profile;
  let response = await sessioned_client(token).post(url, data, { headers });
  const { model } = response.data.result;
  return model;
}

export async function list_visual(routine_id, { query }) {
  const url = get_api_path("routine/visual/list", query, { routine_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function del_visual(routine_id, asset_id) {
  const url = get_api_path("routine/visual/delete", {}, { routine_id, asset_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};